export function FrisbeeDisc() {
  return (
    <g>
      <ellipse rx="24" ry="7" fill="#e7763f" />
      <ellipse cy="-3" rx="24" ry="7" fill="#ffd06e" />
      <ellipse cy="-4" rx="16" ry="3.5" fill="none" stroke="#fff6ca" strokeWidth="2" />
    </g>
  )
}
